import React from 'react';
import { Button, Space } from 'antd';
import { CaretRightOutlined, RedoOutlined, StepForwardOutlined } from '@ant-design/icons';
import { useExecutionContext } from '../contexts/ExecutionContext';

interface DebugTBProps {
    onRun?: () => void;
    onNextStep?: () => void;
    handleRestart?: () => void;
}

const DebugTB: React.FC<DebugTBProps> = ({ onRun, onNextStep, handleRestart }) => {
    const {
        isRunning,
        isPaused,
        // start,
        // restart,
        // pause, 
        // resume,
        // stop,
        // logs 
    } = useExecutionContext();

    return (
        <Space className={isRunning ? 'tilmi-toolbar tilmi-run-active' : 'tilmi-toolbar'}>
            {/* <Button onClick={start} disabled={isRunning && !isPaused}>Start</Button> */}
            {/* <Button onClick={pause} disabled={!isRunning || isPaused}>Pause</Button>
            <Button onClick={resume} disabled={!isRunning || !isPaused}>Resume</Button> */}
            {/* <Button onClick={stop} disabled={!isRunning}>Stop</Button> */}
            <Button onClick={handleRestart} icon={<RedoOutlined />} danger>Restart</Button>
            <Button onClick={onNextStep} icon={<StepForwardOutlined />} disabled={!isRunning || isPaused}>Next Step</Button>
            <Button
                onClick={onRun}
                icon={<CaretRightOutlined />}
                disabled={!isRunning || isPaused}
                style={{ background: '#22c55e', color: '#fff' }}
            >
                Run
            </Button>
        </Space>
    );
};

export default DebugTB;
